<template>
  <section class="surface-header rounded-xl grid grid-cols-2 w-full bg-card-primary relative p-1">
    <div class="text-2xl font-extrabold flex items-center justify-start relative">
      
      <h2 class="ml-4 text-xl font-extrabold flex items-center gap-1">
        <span class="text-brand-primary font-black">ADMIN</span> <span class="font-thin tracking-tighter">DASHBOARD</span>
        <span v-if="!useRuntimeConfig().public.vercelProd" class="text-xs text-orange-500">
          <span v-if="  useRuntimeConfig().public.isDevelopment " class="text-xs text-orange-500">Development mode</span>
          <span v-if="!useRuntimeConfig().public.vercelProd && !useRuntimeConfig().public.isDevelopment" class="text-xs text-orange-500">{{useRuntimeConfig().public.vercel_env}}</span>

        </span>
      </h2>
      <!-- <img src="https://www.pharmanord.dk/static/CKFinderJava/userfiles/images/pharmanord/pharmanord-logo-large.png" alt="Dashboard Logo" class="w-full max-w-[250px] h-auto" /> --> <!-- pragma: allowlist secret -->
    </div>

    <div class="iconBar h-auto flex items-center justify-end gap-4">

      <headerIconBar>
      </headerIconBar>
    </div>

  </section>
</template>

<script setup lang="ts">
import type { UserInfo } from '~/types/pages/userInfo';

const userName = useCookie<UserInfo>('USERINFO');

const useSelectedClient = useState('selectedClient');
const useSelectedWebsite = useState('selectedWebsite');



</script>

<style scoped>
.animated-gradient {
  background: linear-gradient(90deg, #10b981, #3b82f6, #8b5cf6, #ec4899, #10b981);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradient-flow 2s ease infinite;
}

@keyframes gradient-flow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>